import {doNothing} from '@raison/toolbox';
import {RsnCheckbox, RsnDialog, RsnIconWidget} from '@raison/ui-kit';
import React, {useState} from 'react';
import {TransactionsHistory, TransactionStatus} from '~/entities/transactions-history';
import {TransactionIcons} from '~/features/transitions-list';
import {FilterPopupLayout} from '../FilterPopupLayout';
import BottomButtons from './BottomButtons/BottomButtons';
import {isFilterUnchanged} from './shared';

const {completed, pending, rejected} = TransactionIcons;

type TypeOptions = {
    label: string;
    status: TransactionStatus;
    logo: string;
};

const optionsList: TypeOptions[] = [
    {
        label: 'Completed',
        status: 'completed',
        logo: completed,
    },
    {
        label: 'Pending',
        status: 'pending',
        logo: pending,
    },
    {
        label: 'Rejected',
        status: 'rejected',
        logo: rejected,
    },
];

export const StatusFilterPopup = () => {
    const {onClose: close = doNothing} = RsnDialog.useControls();
    const [{status: appliedFilter}, {apply: applyFilters}] = TransactionsHistory.useFilters();

    const [checkedBoxes, setSelected] = useState(new Set(appliedFilter));

    const nothingChanged = isFilterUnchanged(appliedFilter, checkedBoxes);
    const nothingSelected = checkedBoxes.size === 0;

    const onChange = (itemName: TransactionStatus, checked: boolean) => {
        setSelected(prevState => {
            if (checked) {
                return new Set(prevState).add(itemName);
            } else {
                return new Set(Array.from(prevState).filter(status => status !== itemName));
            }
        });
    };

    const onApply = () => {
        applyFilters({status: Array.from(checkedBoxes)});
        close();
    };

    const onClear = () => {
        setSelected(new Set());
    };

    return (
        <FilterPopupLayout
            title='Operation status'
            padding={'none'}
            footer={
                <BottomButtons
                    isApplyDisabled={nothingChanged}
                    isClearHidden={nothingSelected}
                    applyCallback={onApply}
                    clearCallback={onClear}
                />
            }
        >
            <div className='flex flex-col'>
                {optionsList.map(({label, status, logo}) => (
                    <RsnIconWidget.Lg
                        key={label}
                        icon={{src: logo}}
                        as='label'
                        className={'p-4'}
                        addon={
                            <RsnCheckbox
                                onChange={e => onChange(status, e.target.checked)}
                                checked={checkedBoxes.has(status)}
                            />
                        }
                    >
                        <RsnIconWidget.Text children={label} />
                    </RsnIconWidget.Lg>
                ))}
            </div>
        </FilterPopupLayout>
    );
};
